export function daysInStage(updatedAt) {
  if (!updatedAt) return null;
  const days = Math.floor((Date.now() - new Date(updatedAt).getTime()) / 86400000);
  if (days === 0) return 'Today';
  if (days === 1) return '1 day';
  return `${days} days`;
}

export function stageAgeColor(updatedAt) {
  if (!updatedAt) return '';
  const days = Math.floor((Date.now() - new Date(updatedAt).getTime()) / 86400000);
  if (days >= 14) return 'text-red-500';
  if (days >= 7) return 'text-amber-500';
  return 'text-gray-400';
}
